import { useTranslation } from 'react-i18next';

import { SerializableAnnotation } from '../../../types';
import { Button } from '../../shadcn-ui/button';
import {
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../shadcn-ui/dialog';
import { ScrollArea } from '../../shadcn-ui/scroll-area';
import ImageViewer from './ImageViewer';
import React, { useCallback, useState } from 'react';


type AnnotationViewerProps = {
  annotation: Pick<SerializableAnnotation, 'title' | 'description' | 'description_short'> &
    Partial<Pick<SerializableAnnotation, 'position' | 'cameraPosition'>>;
};

const AnnotationViewer: React.FC<AnnotationViewerProps> = ({ annotation }) => {
  const { t } = useTranslation();

	let description = annotation.description;
	
	const dom = new DOMParser().parseFromString(description,'text/html');
	let images = dom.querySelectorAll('img');
	
	if (images) {
    	images.forEach(node => { 
    		if (node) {
    			var wrapper = dom.createElement('div');
    			/* a bit quick and dirty, not react-like, but common libraries failed */
    			//wrapper.setAttribute('onClick','imageEnlarge(this)');
    			if (node && node.parentNode) node.parentNode.insertBefore(wrapper, node);
	    		wrapper.appendChild(node);    	    			
    		}
    	})
	}

	description = dom.documentElement.innerHTML+' <div id="sometest"></div>';	

  return (
    <DialogContent className="light isViewer" aria-describedby="" >
      <DialogHeader>
        <DialogTitle className="text-foreground">
          {annotation.title}
        </DialogTitle>
      </DialogHeader>

      <ScrollArea>
        <div
          className="orto-quill-viewer text-foreground [&_a]:text-[revert]"
          dangerouslySetInnerHTML={{ __html: description }}

			onClick= {(e) => {
				var el = e.target as HTMLElement;  
        		if (el.tagName === 'IMG') {
        			var viewer = document.getElementsByClassName('isViewer')[0]
        			if (el.classList.contains('imageEnlarge')) {
        				el.className = 'imageNormal';
        				//viewer.target.className += ' sometest';
        			} else {
        				//viewer.target.className += ' sometest';
        				el.className = 'imageEnlarge';
        			}
        		}
			}}   
			

/*		
			onClick= {(e) => {
				var el = e.target as HTMLElement;   
        		if (el.tagName === 'IMG') {
        		}
			}}
*/        
        ></div>
      </ScrollArea>

      <DialogFooter className="flex gap-4">
        <DialogClose asChild>
          <Button
            type="submit"
            className="bg-primary capitalize text-primary-foreground"
          >
            {t('close')}
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};

export default AnnotationViewer;
